<template>
  <div class="jm-dict-select">
    <template v-if="show">
      <span :class="textClass">{{ text }}</span>
    </template>
    <template v-else>
      <el-select
        @change="(v) => $emit('change', v)"
        v-if="internalType === 'dataset'"
        :class="classList"
        v-model="dictVal"
        v-bind="$attrs">
        <el-option
          v-for="item in renderDs"
          :value="item.value"
          :label="getLabel(item)"
          :key="item.value"/>
      </el-select>
      <el-select
        @clear="(v) => $emit('clear', v)"
        @change="(v) => $emit('change', v)"
        @visible-change="visibleChange"
        v-else
        :class="classList"
        v-bind="$attrs"
        v-model="dictVal">
        <el-option
          v-for="item in renderDs"
          :value="item.id"
          :label="item.value"
          :key="item.id"
          v-bind="$attrs"/>
      </el-select>
    </template>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  name: 'JmDictSelect',
  props: {
    dictType: {
      type: [String, Array],
    },
    pid: {
      type: [String, Number],
      default: ''
    },
    name: {
      type: [String, Array],
    },
    value: [Number, String, Array, Boolean],
    modifier: {
      type: Function,
    },
    filter: {
      type: Function,
    },
    type: {
      type: String,
      default: 'online'
    },
    textClass: {
      type: String,
      default: '',
    },
    show: {
      type: Boolean,
      default: false,
    },
    refresh: {
      type: Boolean,
      default: false,
    },
    visible: {
      type: Boolean,
      default: null,
    },
    dictlist: {
      type: [Object, Array],
      default: null,
    },
    emptyLabel: {
      type: String,
      default: null,
    },
    emptyValue: {
      type: [Number, String],
      default: '',
    },
    dict: {
      type: String,
      default: null,
    },
    valueType: {
      type: String,
      default: 'number',
    }
  },
  model: {
    event: 'change'
  },
  data() {
    return {
      ds: [],
      dictVal: null,
      classList: [],
      inited: false,
      internalDictType: null,
      internalType: null,
      internalName: null,
    };
  },
  computed: {
    text() {
      let result = '';
      if (this.internalType === 'dataset') {
        let index = this.ds.findIndex((item) => {
          return item.value === Number(this.dictVal);
        });
        if (index > -1) {
          result = this.getLabel(this.ds[index]);
        }
        return result;
      }
      if (String(this.internalType) !== '') {
        this.ds.forEach((item) => {
          if (item.id === this.dictVal) {
            result = item.value;
          }
        });
        return result;
      }
      for (let i = 0; i < this.ds.length; i++) {
        if (this.ds[i].id === this.dictVal) {
          return this.ds[i].value;
        }
      }
      return '';
    },
    renderDs() {
      if (this.ds.length > 0) {
        if (this.filter) {
          return this.ds.filter(this.filter);
        }
        return this.ds;
      }
    },
    isMultiple() {
      return 'multiple' in this.$attrs && this.$attrs.multiple !== false;
    },
    ...mapGetters([
      'jiemoDict',
      'onlineDict',
      'collegeDict',
      'datasetDicts',
      'jobDict',
      'trainingDict'
    ]),
  },
  methods: {
    getDatasource() {
      if (this.internalType === 'dataset') {
        return this.getDatasetDatasource();
      }

      if (this.internalType !== '' && (`${this.internalType}Dict` in this)) {
        return this[`${this.internalType}Dict`];
      }

      if (!this.dictlist) {
        return this.dictlist;
      }
      throw new Error(`Not support type: ${this.internalType} dict-type: ${this.internalDictType} name: ${this.internalName}`);
    },

    /**
     * 数据集合数据源
     *
     * @author Cong Peijun <congpeijun@jiemo.net>
     * @return {Promise} [description]
     */
    getDatasetDatasource() {
      return this.datasetDicts[this.internalDictType];
    },

    getDs(ds) {
      if (this.dictlist && this.dictlist.length) {
        return this.dictlist;
      }
      if (this.internalType === 'dataset') {
        if (Array.isArray(this.internalName)) {
          let temp = [];
          this.internalName.forEach((item) => {
            if (!ds[item]) {
              throw new Error(`未定义/dataset/${this.internalDictType}@${item}`);
            }
            temp = [...temp, ...ds[item]];
          });
          return temp;
        }

        if (!ds || !ds[this.internalName]) {
          throw new Error(`未定义/dataset/${this.internalDictType}@${this.internalName}`);
        }
        return ds[this.internalName];
      }

      if (Array.isArray(this.internalDictType)) {
        let temp = [];
        this.internalDictType.forEach((item) => {
          temp = [...temp, ...ds[item]];
        });
        return temp;
      }
      // 修改 szq
      if (this.emptyLabel) {
        let setData = {};
        setData.id = this.emptyValue;
        setData.value = this.emptyLabel;
        let newData = [];
        return newData.concat(setData, ds[this.internalDictType]);
      }
      return ds[this.internalDictType];
    },
    /**
     * 处理默认显示数据， 排除不在字典列表内数据
     *
     * @author Cong Peijun <congpeijun@jiemo.net>
     * @param  {Number} val
     * @return {Number}
     */
    getDefaultVal(val) {
      if (this.valueType === 'number' && this.dictVal !== '') {
        val = +val;
        if (!Number.isInteger(val)) {
          val = '';
        }
      }
      if (this.internalType === 'dataset') {
        for (let i = 0; i < this.ds.length; i++) {
          if (this.ds[i].value === val) {
            return val;
          }
        }
        return '';
      }

      if (this.internalType !== '') {
        if (this.internalType === 'job') {
          return String(val);
        }
        if (this.internalType === 'training') {
          return String(val);
        }
        if (val || this.internalType === 'jiemo') {
          if (val === null) {
            val = '';
          }
          return this.internalType === 'jiemo' ? String(val) : Number(val);
        }
        return val;
      }
      return (val === 0) ? '' : val;
    },
    /**
     * 多选默认值
     */
    getDefaultMultipleVal(value) {
      if (!this.isMultiple) {
        throw new Error('不是多选');
      }
      console.log(value);
      // TODO: 支持多选
    },
    initialize(value = this.value) {
      this.ds = this.getDs(this.getDatasource());
      if (this.modifier && !this.inited) {
        this.ds = this.ds.map(this.modifier);
      }
      this.$nextTick(() => {
        if (this.internalType === 'dataset') { // 如果是dataset， 可以为0
          this.dictVal = this.getDefaultVal(value);
        } else {
          this.dictVal = this.emptyValue !== value && this.getDefaultVal(value) === 0 ?
            null : this.getDefaultVal(value);
        }
        this.inited = true;
      });
    },
    visibleChange(v) {
      if (this.visible !== null) {
        this.$emit('update:visible', v);
      }
    },
    /**
     * 获取label，支持多语言
     */
    getLabel(item) {
      const locale = this.$i18n.locale;
      const labelKey = `label_${locale}`;
      if (item[labelKey]) {
        return item[labelKey];
      }
      return item.label;
    },
    initializeCreate() {
      if (this.dict) {
        [this.internalType, this.internalDictType, this.internalName] = this.dict.split('.');
      } else {
        this.internalDictType = this.dictType;
        this.internalType = this.type;
        this.internalName = this.name;
      }
    },
    doInit() {
      this.dictVal = null;
      this.$emit('change', null);
      this.initializeCreate();
      this.initialize();
    }
  },
  created() {
    this.initializeCreate();
  },
  mounted() {
    this.initialize();
    // 继承class
    this.$nextTick(() => {
      let classList = this.$el.className;
      classList = classList.replace('jm-dict-select', '');
      this.classList = classList.split(' ');
      this.$el.className = 'jm-dict-select';
    });
  },
  watch: {
    pid(val) {
      this.filter = (item) => {
        return item.pid === val;
      };
    },
    refresh(val) {
      if (val === true) {
        this.dictVal = null;
        this.$emit('update:refresh', false);
      }
    },
    value(value) {
      this.initialize(value);
    },
    dictType(n, o) {
      o && this.doInit();
    },
    dict(n, o) {
      o && this.doInit();
    },
    type(n, o) {
      o && this.doInit();
    }
  }
};
</script>
<style scoped>
  .jm-dict-select .el-select{
    width: 100%;
  }
</style>
